import React from 'react'

const Page404: React.FC = () => <div data-testid={'page-404'}>404</div>

export default Page404
